// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Payment_form as Payment_form_impl} from '../plus/payment_form_hola2023_theme';
import {use_premium_page} from '../ui/premium/use_premium_page';
import {Editor} from '../../../shared/editor/editor';

export const Payment_form = ()=>{
    const {theme} = useContext(Settings_context);
    const {is_payment_form_open, opt} = use_premium_page({from_bext: false});
    return <div className={theme.content_center}>
      <Payment_form_impl visible={is_payment_form_open}
        opt={opt} all_plans_test={true} payment_btn_on_top={true}/>
    </div>;
};

interface i_plans_as_boxes_editor_props {
    value: unknown;
    on_change: (newValue: unknown)=>void;
}

export const Payment_form_editor = (props: i_plans_as_boxes_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
